import { render, staticRenderFns } from "./story-item.vue?vue&type=template&id=79ff6a48&"
import script from "./story-item.vue?vue&type=script&lang=js&"
export * from "./story-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports